const birthYearSelectOptions = () => {
  const array = [];
  const currentYear = new Date().getFullYear();
  for(let i = currentYear; i>=1900; i--) {
    array.push({value: i, label: i});
  }
  return array;
}

export const registerFormContentsEn = {
  header: 'Welcome to Awair',
  headerDescription: `To get started, you'll need to create an account with Awair by filling out the form below.(*required)`,
  passwordGuide: 'At least 6 characters, including 1 letter and 1 number',
  confirmPasswordGuide: 'Your confirmation password does not match your new password',
  requiredGuide: 'This is required',
  labelText: {
    email: 'Email*',
    password: 'Password*',
    confirmPassword: 'Confirm Password*',
    firstName: 'First Name',
    lastName: 'Last Name',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    birthYears: 'Birth Years'
  },
  placeholderText: {
    password: 'New Password',
    confirmPassword: 'Confirm Password',
    firstName: 'First Name',
    lastName: 'Last Name'
  },
  submitButtonText: 'SUBMIT',
  contactUsDescription: 'If you have any questions, please reach out to us at',
  birthYearSelectOptions: birthYearSelectOptions()
}

export const registerFormContentsKr = {
  header: '어웨어 회원가입',
  headerDescription: '어웨어를 이용하시려면 아래 항목을 기입해 가입을 완료하여 주십시오. (* 필수항목)',
  passwordGuide: '숫자와 문자 1개씩을 포함하여 6자 이상 기입해주십시오.',
  confirmPasswordGuide: '비밀번호가 일치하지 않습니다.',
  requiredGuide: '기입이 필요한 항목 입니다.',
  labelText: {
    email: '이메일 주소*',
    password: '비밀번호*',
    confirmPassword: '비밀번호 확인*',
    firstName: '이름',
    lastName: '성',
    gender: '성별',
    male: '남성',
    female: '여성',
    birthYears: '탄생년도'
  },
  placeholderText: {
    password: '비밀번호 입력',
    confirmPassword: '비밀번호 확인',
    firstName: '이름',
    lastName: '성'
  },
  submitButtonText: '가입 완료',
  contactUsDescription: '어웨어 제품/이용 문의는 이메일로 연락주세요. ',
  birthYearSelectOptions: birthYearSelectOptions()
}